
import { GoogleGenAI, Type } from "@google/genai";
import { AIPromptResponse } from "../types";

export const getAISuggestion = async (leftoverIngredient: string): Promise<AIPromptResponse> => {
  // Se instancia el cliente dentro de la función para asegurar que process.env.GEMINI_API_KEY esté disponible tras la carga/inyección.
  const ai = new GoogleGenAI({ apiKey: process.env.GEMINI_API_KEY });
  
  try {
    const response = await ai.models.generateContent({
      model: "gemini-3-flash-preview",
      contents: `Como experto en marketing gastronómico para 'Arte-Sano', propón un producto innovador para niños de 2 a 10 años usando mermas o insumos locales de la costa caribe colombiana, específicamente centrándote en: ${leftoverIngredient}. 
      El tono debe ser elegante y artesanal.`,
      config: {
        responseMimeType: "application/json",
        responseSchema: {
          type: Type.OBJECT,
          properties: {
            name: { type: Type.STRING, description: "Nombre creativo y llamativo" },
            description: { type: Type.STRING, description: "Descripción vendedora y apetitosa" },
            benefit: { type: Type.STRING, description: "Beneficio nutricional claro" },
            reason: { type: Type.STRING, description: "Por qué es una opción rentable (uso de mermas)" }
          },
          required: ["name", "description", "benefit", "reason"]
        }
      }
    });

    const text = response.text;
    if (!text) throw new Error("La IA no devolvió contenido.");

    return JSON.parse(text.trim());
  } catch (error) {
    console.error("Error en sugerencia IA:", error);
    throw error;
  }
};

export interface SensoryProfile {
  notes: string;
  pairing: string;
  mood: string;
}

export const getSensoryProfile = async (productName: string, description: string): Promise<SensoryProfile> => {
  const ai = new GoogleGenAI({ apiKey: process.env.GEMINI_API_KEY });
  
  try {
    const response = await ai.models.generateContent({
      model: "gemini-3-flash-preview",
      contents: `Como sommelier de panadería artesanal, describe el perfil sensorial y el maridaje perfecto para el producto: "${productName}" (${description}). 
      Enfócate en ingredientes y bebidas típicas de Colombia.`,
      config: {
        responseMimeType: "application/json",
        responseSchema: {
          type: Type.OBJECT,
          properties: {
            notes: { type: Type.STRING, description: "Notas de cata (textura, aroma, sabor)" },
            pairing: { type: Type.STRING, description: "Bebida recomendada para acompañar" },
            mood: { type: Type.STRING, description: "Momento ideal del día para consumirlo" }
          },
          required: ["notes", "pairing", "mood"]
        }
      }
    });

    const text = response.text;
    if (!text) throw new Error("La IA no devolvió perfil sensorial.");

    return JSON.parse(text.trim());
  } catch (error) {
    console.error("Error en perfil sensorial:", error);
    throw error;
  }
};
